import { render } from "./Details.vue?vue&type=template&id=8bff4b74&scoped=true&ts=true"
import script from "./Details.vue?vue&type=script&lang=ts&setup=true"
export * from "./Details.vue?vue&type=script&lang=ts&setup=true"

import "./Details.vue?vue&type=style&index=0&id=8bff4b74&lang=scss&scoped=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bff4b74"],['__file',"resources/js/Pages/Orchard/LeavesData/Details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8bff4b74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8bff4b74', __exports__)) {
    console.log('reload')
    api.reload('8bff4b74', __exports__)
  }
  
  module.hot.accept("./Details.vue?vue&type=template&id=8bff4b74&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('8bff4b74', render)
  })

}


export default __exports__